import React, { useEffect, useState, useRef } from 'react';
import Layout from '../components/Layout';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import keycloak from '../keycloak';
import { BACKEND_URL } from '../global';
import { HomeIcon, CheckCircleIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline"
import Select from 'react-select';
import JustrediLoader from '../components/justrediLoader';
import { DeleteElement } from '../file-browser/components';
import { Tooltip } from 'react-tooltip'
import { BASEPATH } from '../global';
import { enqueueSnackbar } from "notistack";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
    Table,
    TableBody,
    TableCell,
    TableClickableHead,
    TableHead,
    TableHeader,
    TableRow,
} from "../shadcnComponents/ui";
import { groupsMenuStyling, groupsMenuTheme } from "../file-browser/reactSelectStyling";
import { ActionBar, NewGroupInput, RenameGroupInput, PaginationElement } from "./components"

export function UserManager() {
    const navigate = useNavigate()
    // Info of currently logged user
    const [loading, setLoading] = useState(true);
    // All users
    const [users, setUsers] = useState([]);
    // All groups
    const [groups, setGroups] = useState([]);
    // Groups per user
    const [userGroups, setUserGroups] = useState(null)
    // Dropdown menu elements for group selection
    const [menu, setMenu] = useState(null)
    // Array of selected files and folders ids
    const selectedElements = useRef([])
    // Array of selected filenames
    const [selectedFileNames, setSelectedFileNames] = useState([])
    // Array of filenames to be deleted
    const [groupnamesToDelete, setGroupnamesToDelete] = useState([])
    // Filename to rename
    const [groupnameToRename, setGroupNameToRename] = useState("")
    // Pagination variables
    const [page, setPage] = useState(1)
    const [pageUsersArray, setPageUsersArray] = useState([[{ id: '', name: '' }]])
    const [pageGroupsArray, setPageGroupsArray] = useState([[{ id: '', name: '' }]])
    const [usersPerPage, setUsersPerPage] = useState(10)
    const [groupsPerPage, setGroupsPerPage] = useState(10)


    // set all page elements
    function paginate(items, itemsPerPage) {
        if (!Array.isArray(items)) {
            throw new TypeError("First argument must be an array");
        }
        if (typeof itemsPerPage !== "number" || itemsPerPage <= 0) {
            throw new Error("Items per page must be a positive integer");
        }

        const pages = [];
        for (let i = 0; i < items.length; i += itemsPerPage) {
            pages.push(items.slice(i, i + itemsPerPage));
        }
        return pages;
    }

    useEffect(() => {
        setPageUsersArray(paginate(users, usersPerPage))
    }, [users, usersPerPage])

    useEffect(() => {
        setPageGroupsArray(paginate(groups, groupsPerPage))
    }, [groups, groupsPerPage])

    useEffect(() => {
        setPage(1)
    }, [pageGroupsArray, pageUsersArray])

    async function fetchData() {
        const headers = { Authorization: `Bearer ${keycloak.token}` };
        const [uRes, gRes] = await Promise.all([
            axios.get(BACKEND_URL + "/users", { headers, validateStatus: () => true }),
            axios.get(BACKEND_URL + "/groups", { headers, validateStatus: () => true }),
        ]);
        setLoading(false)
        if (uRes.status == 200 && gRes.status == 200) {
            setUsers(uRes.data);
            setGroups(gRes.data);
        } else {
            navigate('/home')
        }
    }

    useEffect(() => {
        if (!keycloak.authenticated) {
            navigator('/login')
        } else {
            // Fetch files
            fetchData()
            document.addEventListener("mousedown", handleClickAnywhere);
            return () => {
                document.removeEventListener("mousedown", handleClickAnywhere);
            };
        }
    }, [])

    function compareArraysById(dataBaseValues, newValues) {
        let onlyInArr1 = []
        let onlyInArr2 = []
        if (newValues) {
            const map1 = new Map(dataBaseValues.map(obj => [obj.value, obj]));
            const map2 = new Map(newValues.map(obj => [obj.value, obj]));
            onlyInArr1 = [...map1.values()].filter(obj => !map2.has(obj.value));
            onlyInArr2 = [...map2.values()].filter(obj => !map1.has(obj.value));
        } else {
            const map1 = new Map(dataBaseValues.map(obj => [obj.id, obj]));
            onlyInArr1 = [...map1.values()]
            onlyInArr2 = []
        }
        return {
            onlyInArr1,
            onlyInArr2
        };
    }

    const changeGroup = async (newGroups, id) => {
        let listOfChanges = compareArraysById(userGroups[id] ? userGroups[id] : [], newGroups)
        let reloadTriggered = false
        if (listOfChanges.onlyInArr1.length > 0) {
            // Remove User from Group
            await axios.delete(BACKEND_URL + "/users/" + id + '/groups/' + listOfChanges.onlyInArr1[0].value,
                { headers: { Authorization: `Bearer ${keycloak.token}` } }
            )
            reloadTriggered = true
        }
        if (listOfChanges.onlyInArr2.length > 0) {
            // Add user to group
            await axios.post(BACKEND_URL + "/users/" + id + '/groups/' + listOfChanges.onlyInArr2[0].value,
                {},
                { headers: { Authorization: `Bearer ${keycloak.token}` } }
            )
            reloadTriggered = true
        }
        if (reloadTriggered) {
            // reload view
            fetchData();
        }
    };

    useEffect(() => {
        if (groups.length > 0) {
            let menuItems = Array.from(groups, (group) => { return { label: group.name, value: group.id } })
            let index = null
            menuItems.map(each => { if (each.label == 'Realm group managers') { index = menuItems.indexOf(each) } })
            if (index != null) {
                menuItems.splice(index, 1)
            }
            setMenu(menuItems)
        }
    }, [groups])


    useEffect(() => {
        let groupsPerUser = {}
        users.map(user => {
            if (user.groups.length > 0) {
                let currentGroups = []
                user.groups.map(group => {
                    if (group.name != 'Realm group managers') {
                        currentGroups.push({ label: group.name, value: group.id })
                    }
                })
                groupsPerUser[user.id] = currentGroups
            }
        })
        setUserGroups(groupsPerUser)
    }, [users])

    function deleteSelectedGroup() {
        let promiseArray = []
        if (selectedElements.current.length > 0) {
            selectedElements.current.map(element => {
                promiseArray.push(
                    fetch(BACKEND_URL + "/groups/" + element, {
                        method: 'DELETE',
                        headers: { Authorization: `Bearer ${keycloak.token}` },
                    })
                )
            })
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray).then(() => {
                document.getElementById('delete-file').classList.add('hidden')
                selectedElements.current = []
                setSelectedFileNames([])
                fetchData()
            })
        }
    }

    function displayDeleteMenu() {
        let groupnames = []
        selectedElements.current.map(each => {
            groupnames.push(groups.find(element => element.id == each).name)
        })
        if (groupnames.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κάποια ομάδα για διαγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            setGroupnamesToDelete(groupnames)
            document.getElementById('delete-file').classList.remove('hidden')
        }
    }

    function displayRenameMenu() {
        if (selectedElements.current.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κάποια ομάδα για μετονομασία', { variant: 'warning', autoHideDuration: 3000 })
        } else if (selectedElements.current.length > 1) {
            enqueueSnackbar('Επιλέξτε μία μόνο ομάδα για μετονομασία', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            setGroupNameToRename(groups.find(element => element.id == selectedElements.current[0]).name)
            document.getElementById('new-groupname').classList.remove('hidden')
        }
    }

    function addGroup(name) {
        fetch(BACKEND_URL + "/groups", {
            method: 'POST',
            body: JSON.stringify({ name: name }),
            headers: {
                Authorization: `Bearer ${keycloak.token}`,
                'Content-type': 'application/json'

            },
        }).then(res => {
            if (res.status == 200) {
                fetchData()
            }
        })
    }

    function renameGroup() {
        fetch(BACKEND_URL + "/groups/" + selectedElements.current[0], {
            method: 'PATCH',
            body: JSON.stringify({
                name: document.getElementById('new-name').value
            }),
            headers: {
                Authorization: `Bearer ${keycloak.token}`,
                'Content-type': 'application/json'
            },
        }).then(res => {
            if (res.status == 200) {
                document.getElementById('new-groupname').classList.add('hidden');
                setGroupNameToRename("")
                fetchData()
            }
        })
    }

    // Handle click on element
    function handleClick(event, id) {
        // If tick was clicked, perform no action 
        if (!event.target.closest('.check-symbol') && !event.target.closest('.group-management')) {
            // If ctrl is pressed only select-unselect functionality works
            if (event.ctrlKey) {
                // Add element to selected elements or remove if already selected
                let newSelectedElements = [...selectedElements.current]
                // Unselect element
                if (selectedElements.current.includes(id)) {
                    var index = newSelectedElements.indexOf(id);
                    if (index !== -1) {
                        newSelectedElements.splice(index, 1);
                    }
                    document.getElementById(id).classList.remove('bg-accent')
                    document.getElementById(id).classList.remove('selected')
                } else {
                    // Select element
                    newSelectedElements.push(id)
                    document.getElementById(id).classList.add('bg-accent')
                    document.getElementById(id).classList.add('selected')
                }
                selectedElements.current = newSelectedElements
                setSelectedFileNames(selectedElements.current)
            } else {
                // Unselect element
                if (selectedElements.current.includes(id)) {
                    unselectAllElements()
                } else {
                    // Select element
                    selectedElements.current.map(each => {
                        document.getElementById(each).classList.remove('bg-accent')
                        document.getElementById(each).classList.remove('selected')
                    })
                    selectedElements.current = [id]
                    setSelectedFileNames([id])
                    document.getElementById(id).classList.add('bg-accent')
                    document.getElementById(id).classList.add('selected')
                    // }
                }
            }
        }
    }

    function unselectAllElements() {
        selectedElements.current.map(each => {
            if (document.getElementById(each)) {
                document.getElementById(each).classList.remove('bg-accent')
                document.getElementById(each).classList.remove('selected')
            }
        })
        selectedElements.current = []
        setSelectedFileNames([])
    }

    // Handle click outside files-table && action-bar
    function handleClickAnywhere(event) {
        const filesTable = document.getElementById("users-table");
        const groupsTable = document.getElementById("groups-table");
        const actionBar = document.getElementById('action-bar');
        const deleteMenu = document.getElementById('delete-file');
        const renameMenu = document.getElementById('new-groupname');
        if (filesTable && filesTable != event.target && !filesTable.contains(event.target) ||
            groupsTable && groupsTable != event.target && !groupsTable.contains(event.target) &&
            actionBar != event.target && !actionBar.contains(event.target) &&
            deleteMenu != event.target && !deleteMenu.contains(event.target) &&
            renameMenu != event.target && !renameMenu.contains(event.target)
        ) {
            unselectAllElements()
        }
    }

    // Handle click on tick symbol
    function clickTick(id) {
        let newSelectedElements = []
        // Remove from selection
        if (selectedElements.current.includes(id)) {
            newSelectedElements = [...selectedElements.current]
            var index = newSelectedElements.indexOf(id);
            if (index !== -1) {
                newSelectedElements.splice(index, 1);
            }
            document.getElementById(id).classList.remove('bg-accent')
            document.getElementById(id).classList.remove('selected')
        } else {
            // Add to selection
            newSelectedElements = [...selectedElements.current, id]
            document.getElementById(id).classList.add('bg-accent')
            document.getElementById(id).classList.add('selected')
        }
        selectedElements.current = newSelectedElements
        setSelectedFileNames(newSelectedElements)
    }

    return (
        <Layout authenticated={true} sidebar={true}>
            <Tooltip id="tooltip-group" className='!opacity-100' />
            {loading &&
                <JustrediLoader opacity={false} />
            }
            <div className="flex flex-col items-start justify-start w-full px-6 pt-14 pb-6">
                <Tabs className="w-full" defaultValue="users">
                    <TabsList>
                        <TabsTrigger onClick={() => { setPage(1) }} value="users">Χρήστες</TabsTrigger>
                        <TabsTrigger onClick={() => { setPage(1) }} value="groups">Ομάδες</TabsTrigger>
                    </TabsList>
                    <TabsContent value="users">
                        <Table id="users-table">
                            <TableHeader>
                                <TableRow className="text-left cursor-default">
                                    <TableHead className="w-[30px] pl-[10px]"></TableHead>
                                    <TableClickableHead className="w-4/12">Χρήστης</TableClickableHead>
                                    <TableClickableHead className="w-[calc(8/12-30px)]">Ομάδα</TableClickableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {users.length > 0 && pageUsersArray[page - 1] && pageUsersArray[page - 1].map((each, index) =>
                                    <TableRow className='selectable-element group' onClick={(e) => { e.preventDefault(); handleClick(e, each.id) }} key={each.id} id={each.id}>
                                        <TableCell className="w-[20px] pl-[30px]">
                                            <CheckCircleIcon id={`check-${each.id}`} height={25} className={`${document.getElementById(each.id) && document.getElementById(each.id).classList.contains('selected') ? 'visible' : 'invisible'} check-symbol hover:visible group-hover:visible m-auto text-ring`} onClick={(e) => { e.preventDefault(); clickTick(each.id) }} />
                                        </TableCell>
                                        <TableCell className="w-4/12">
                                            {`${each.firstName} ${each.lastName}`}
                                        </TableCell>
                                        <TableCell className="w-[calc(8/12-30px)]">
                                            <Select
                                                className="group-management multiple-dropdown my-auto min-w-[300px] w-full rounded-lg"
                                                placeholder={'Επιλογή ομάδων'}
                                                isClearable={false}
                                                isMulti={true}
                                                isSearchable={true}
                                                onChange={(e) => { changeGroup(e, each.id) }}
                                                options={menu}
                                                value={userGroups[each.id] && userGroups[each.id].length > 0 ? userGroups[each.id] : []}
                                                theme={groupsMenuTheme}
                                                styles={groupsMenuStyling}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <PaginationElement page={page} setPage={(e) => { setPage(e) }} itemsPerPage={usersPerPage} setItemsPerPage={(e) => { setUsersPerPage(e) }} pageItemsArray={pageUsersArray} />
                    </TabsContent>
                    <TabsContent value="groups">
                        <ActionBar
                            revealNewGroupMenu={() => { document.getElementById('new-group').classList.remove('hidden') }}
                            revealRenameGroupMenu={() => { displayRenameMenu() }}
                            revealDeleteGroupMenu={() => { displayDeleteMenu() }} />
                        <Table id="groups-table">
                            <TableHeader>
                                <TableRow className="text-left cursor-default">
                                    <TableHead className="w-[30px] pl-[10px]"></TableHead>
                                    <TableClickableHead className="w-[calc(100%-30px)]">Ομάδα</TableClickableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {groups.length > 0 && pageGroupsArray[page - 1] && pageGroupsArray[page - 1].map((each, index) =>
                                    each.name != 'Realm group managers' &&
                                    <TableRow className='selectable-element group h-[55px] p-2' onClick={(e) => { e.preventDefault(); handleClick(e, each.id) }} key={each.id} id={each.id}>
                                        <TableCell className="w-[20px] pl-[30px]">
                                            <CheckCircleIcon id={`check-${each.id}`} height={25} className={`${document.getElementById(each.id) && document.getElementById(each.id).classList.contains('selected') ? 'visible' : 'invisible'} check-symbol hover:visible group-hover:visible m-auto text-ring`} onClick={(e) => { e.preventDefault(); clickTick(each.id) }} />
                                        </TableCell>
                                        <TableCell className="w-[calc(100%-30px)]">
                                            {each.name}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <PaginationElement page={page} setPage={(e) => { setPage(e) }} itemsPerPage={groupsPerPage} setItemsPerPage={(e) => { setGroupsPerPage(e) }} pageItemsArray={pageGroupsArray} />
                    </TabsContent>
                </Tabs>
            </div>
            <NewGroupInput createGroup={(name) => { addGroup(name) }} />
            <RenameGroupInput rename={() => { renameGroup() }} groupnameToRename={groupnameToRename} />
            <DeleteElement unsetNamesToDelete={() => { setSelectedFileNames([]) }} namesToDelete={groupnamesToDelete} deleteSelected={() => { deleteSelectedGroup() }} />
        </Layout >
    )
}

export default UserManager